import { type ReactNode } from 'react';
import clsx from 'clsx';
import styles from './RangeMark.module.scss';

interface Props {
  align?: 'start' | 'center' | 'end';
  children?: ReactNode;
  selected?: boolean;
  widht?: boolean;
}

export function RangeMark({ align = 'center', children, selected, widht }: Props) {
  return (
    <div
      className={clsx(
        styles['range-mark'],
        styles[`range-mark-align-${align}`],
        (!children || widht === false) &&
          widht !== true &&
          styles['range-mark-empty'],
      )}
    >
      <div
        className={clsx(
          styles['range-mark-indicator'],
          selected && styles['range-mark-indicator-selected'],
        )}
      />
      {children && <div className={styles['range-mark-label']}>{children}</div>}
    </div>
  );
}
